(function () {
    'use strict';

    angular
        .module('app')
        .controller('RoutesTerminalController', RoutesTerminalController);

    RoutesTerminalController.$inject = ['$scope', '$rootScope', '$route', '$routeParams', '$location', '$timeout', '$filter', '$translate',
        'blockUI', '$uibModal', 'RoutesTerminalService', 'SelectService', 'NotifyService', 'ExportService', 'TanksService', 'CustomerService'];

    function RoutesTerminalController($scope, $rootScope, $route, $routeParams, $location, $timeout, $filter, $translate,
                                      blockUI, $uibModal, RoutesTerminalService, SelectService, NotifyService, ExportService, TanksService, CustomerService) {
        $scope.data = {
            active: [
                {id: 'all', title: 'All'},
                {id: 'yes', title: 'Yes'},
                {id: 'no', title: 'No'},
            ],
            registerTypes: [
                {id: 'register', title: 'TEXT_MODE_REGISTER'},
                {id: 'steward', title: 'TEXT_MODE_STEWARD'},
                {id: 'validator', title: 'TEXT_MODE_VALIDATOR'},
                {id: 'prepaid-services', title: 'TEXT_MODE_PREPAID_SERVICES'},
                {id: 'road-tanker-driver', title: 'TEXT_MODE_ROAD_TANKER_DRIVER'},
                {id: 'kiosk', title: 'TEXT_MODE_KIOSK'}
            ],
            routeStatusTypes: [
                {id: 'canceled', title: 'routeStatus#canceled'},
                {id: 'failed', title: 'routeStatus#failed'},
                {id: 'pending', title: 'routeStatus#pending'},
                {id: 'processed', title: 'routeStatus#processed'}
            ],
            minDate: new Date(),
            corruptedFields: []
        };
        $scope.getFiltersList = SelectService.getLPRList;
        $scope.getPages = getTotalPaginatedPages;
        $scope.route = {
            date: moment().format('YYYY-MM-DD'),
            terminal_id: null,
            active: 1,
            comment: ''
        };

        $scope.routesTerminal = [];
        $scope.routesTerminalSummary = undefined;
        $scope.params = {
            page: 1,
            count: 20,
            active: 'all'
        }

        $scope.table_cols_route_operations = [
            {
                visible: true,
                data: [
                    {
                        value: 'scheduled',
                        text: 'Route operation time',
                        visible: true
                    },
                    {
                        value: 'comment',
                        text: 'Route operation comment',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'quantity',
                        text: 'Route operation quantity',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'ullage_volume',
                        text: 'Tank ullage_volume',
                        visible: true
                    },
                    {
                        value: 'product_volume',
                        text: 'Tank product volume',
                        visible: true
                    },

                    {
                        value: 'volume',
                        text: 'Tank volume',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'code',
                        text: 'Tank code',
                        visible: true
                    },
                    {
                        value: 'tank_title',
                        text: 'Tank title',
                        visible: true
                    },
                    {
                        value: 'goods_code',
                        text: 'Tank linked goods code',
                        visible: true
                    },


                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'status',
                        text: 'Route operation status',
                        visible: true
                    }
                ]
            },
        ]
        $scope.table_cols = [
            {
                visible: true,
                data: [
                    {
                        value: 'date',
                        text: 'Route date',
                        visible: true,
                        sorting: 'date'
                    },
                    {
                        value: 'comment',
                        text: 'Route comment',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'terminal_title',
                        text: 'Register or Salesperson name',
                        visible: true,
                        sorting: 'terminal_title'
                    }, {
                        value: 'terminal_id',
                        text: 'ID',
                        visible: true
                    }, {
                        value: 'terminal_type',
                        text: 'Operation mode',
                        visible: true,
                        sorting: 'terminal_type'
                    },
                ]
            },

            {
                visible: true,
                data: [
                    {
                        value: 'operations_count',
                        text: 'Route operations count',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'active',
                        text: 'Active',
                        visible: true,
                        sorting: 'active'
                    }
                ]
            },
        ];

        $scope.getFiltersList = SelectService.getLPRList;
        var block_routes_terminal_list = blockUI.instances.get('routes-terminal-list'),
            block_route_operations_list = blockUI.instances.get('route-operations-list'),
            block_route_form = blockUI.instances.get('route-terminal-form');

        initController();

        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('routeID')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }

        }

        function initController() {
            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;

                case 'show':
                    doShow();
                    break;

                case 'edit':
                    doEdit();
                    break;
            }
        }

        function doShow() {
            $scope.route = {
                date: moment().format('YYYY-MM-DD'),
                terminal_id: null,
                active: 1,
                comment: ''
            };
            $scope.routeOperations = {};
            getRoutesTerminal();
        }

        function doCreate() {
            block_route_form.start();
            $scope.data.minDate = new Date();
            $scope.data.corruptedFields = [];
            $scope.route = {
                date: '',//moment().format('YYYY-MM-DD'),
                terminal_id: null,
                active: 1,
                comment: ''
            };
            $scope.routeOperations = {};
            block_route_form.stop();
        }

        function doEdit() {
            $scope.data.corruptedFields = [];
            var routeID = $routeParams.routeID;

            $scope.route = {};
            $scope.routeOperations = {};
            block_route_form.start();

            RoutesTerminalService.GetRoute(routeID, function (success, data) {
                if (success) {
                    $scope.route = angular.copy(data);
                    $scope.data.minDate = moment($scope.route.date);
                    SelectService.getLPRList(function (LPR_LIST) {
                        $scope.route.terminal = itemByIndex($scope.LPR_LIST, $scope.route.terminal_id);
                        refreshRouteOperations(function (success, data) {
                            if (success) {
                                $scope.routeOperations = data;
                            } else {
                                location.path('/routes-terminal');
                            }
                            block_route_form.stop();
                        })
                    });
                } else {

                    location.path('/routes-terminal');
                    block_route_form.stop();
                }

            })
        }

        function refreshRouteOperations(callback) {
            block_route_operations_list.start();
            RoutesTerminalService.GetRouteOperations($routeParams.routeID, function (success, data) {
                $scope.routeOperations = data;
                if (callback) {
                    callback(success, data)
                }
                block_route_operations_list.stop();
            });
        }

        $scope.popupRouteOperation = function (routeOperation) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/pages/routes-terminal/modal/route-operation.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {

                    var popup = this;

                    var block_form_route_operation = blockUI.instances.get('form-route-operation');
                    popup.set_product_volume = 0;


                    popup.tanksPage = 1;
                    popup.corruptedFields = [];
                    popup.routeStatusTypes = angular.copy($scope.data.routeStatusTypes);

                    popup.routeOperation = routeOperation ? angular.copy(routeOperation) : {
                        scheduled: '',
                        comment: '',
                        status: 'pending',
                        type: 'sale-fuel-to-tank',
                        details: {
                            quantity: '',
                            tank_id: '',
                        }
                    };
                    if (popup.routeOperation.id) {
                        popup.routeOperation.scheduled = moment(popup.routeOperation.scheduled, 'HH:mm:ss').toDate()
                    }

                    popup.tanksData = {
                        data: [],
                        total_rows_count: undefined
                    };
                    popup.isTanksLoading = false;
                    popup.searchCustomerField = {
                        searchText: '',
                        onCustomerFieldSelect: function ($item) {
                            block_form_route_operation.start();
                            popup.searchCustomerField.searchCustomer = $item;
                            delete popup.searchCustomerField.searchText;
                            popup.getTanksLinked(function (success, data) {


                                block_form_route_operation.stop();
                            });

                        },
                        getSearchCustomers: function (val) {
                            return new Promise(function (resolve) {
                                var params = {
                                    search_text: val,
                                    customer_type: $scope.params.owner_type,
                                    page: 1,
                                    count: 5
                                }
                                CustomerService.AllTypeCustomers(params, function (success, data) {
                                    if (success) {
                                        resolve(data.data);
                                    }
                                });
                            })
                        },
                        removeCustomer: function () {
                            popup.tanksData = {
                                data: [],
                                total_rows_count: undefined
                            };
                            popup.tanksPage = 1;
                            popup.searchCustomerField.searchCustomer = undefined;
                            popup.searchCustomerField.searchText = undefined;
                            popup.routeOperation.details.tank = undefined;
                            popup.preSelectedTankLinked = undefined;
                        }
                    };

                    popup.clearTank = function () {
                        popup.routeOperation.details.tank = undefined;
                        popup.preSelectedTankLinked = undefined;
                    }

                    popup.changedScheduled = function () {
                        var scheduledMoment = moment(popup.routeOperation.scheduled).seconds(0);
                        var minutes = scheduledMoment.minutes();
                        scheduledMoment.minutes(
                            Math.floor(minutes / 10) * 10
                        )
                        popup.routeOperation.scheduled = scheduledMoment.toDate();
                    }
                    popup.getTanksLinked = function (callback) {
                        popup.isTanksLoading = true;
                        TanksService.GetTanksLinked({
                                owner_id: popup.searchCustomerField.searchCustomer.id,
                                page: popup.tanksPage,
                                count: 5
                            },
                            function (success, data) {
                                popup.isTanksLoading = false;
                                if (data.data && data.data.length) {
                                    popup.tanksData.data = popup.tanksData.data.concat(data.data);
                                    popup.tanksData.total_rows_count = data.summary.total_rows_count;
                                    popup.tanksPage++;
                                }
                                if (callback && typeof callback === 'function') {
                                    callback(success, data)
                                }
                            })
                    }

                    popup.getTanksLinkedWoCustomer = function (val) {
                        return new Promise(function (resolve) {
                            TanksService.GetTanksLinked({
                                    search_text: val,
                                    page: 1,
                                    count: 10
                                },
                                function (success, data) {
                                    resolve(data.data)
                                })
                        })
                    }

                    popup.getMoreTanksLinked = function ($event) {
                        $event.stopPropagation();
                        $event.preventDefault();
                        popup.getTanksLinked(function (success, data) {
                        });
                    }

                    popup.onSelectTankLinked = function ($item, loadCustomerTanks) {
                        popup.routeOperation.details.tank = $item;
                        popup.searchCustomerField.searchCustomer = {
                            id: popup.routeOperation.details.tank.owner_id,
                            type: popup.routeOperation.details.tank.owner_type,
                            name: popup.routeOperation.details.tank.owner_name,
                            phone: popup.routeOperation.details.tank.owner_phone,
                            email: popup.routeOperation.details.tank.owner_email,
                        }

                        /**
                         * Загружаем емкости покупателя на случай если пользователь удалит емкость
                         */
                        if (loadCustomerTanks) {
                            popup.tanksPage = 1;
                            popup.getTanksLinked(function (success, data) {
                            });
                        }
                        delete popup.routeOperation.preSelectedTankLinked;
                    }

                    popup.routeOperationValidator = {
                        isScheduledValid: function (formData) {
                            var form = formData || popup.routeOperation;
                            return !!form && !!form.scheduled.toString().length;
                        },
                        isTankValid: function (formData) {
                            var form = formData || popup.routeOperation;
                            return !!form && (form.details.tank || form.details.tank_id);
                        },
                        isCustomerValid: function (formData) {
                            var form = !popup.routeOperation.id ? popup.searchCustomerField : popup.routeOperation;
                            console.log(form)
                            return !!form && (form.searchCustomer && form.searchCustomer.id || form.details && form.details.tank && form.details.tank.owner_id);
                        },
                        isQuantityValid: function (formData) {
                            var form = formData || popup.routeOperation;
                            return !!form && (form.details.quantity || '').toString().length && parseFloat((form.details.quantity || '')) > 0;
                        },
                        isProductVolumeValid: function (formData) {
                            var form = formData || popup.routeOperation;
                            return !!form && (!popup.set_product_volume || (form.details.product_volume && form.details.product_volume.toString().length));
                        },
                    }

                    function validateRouteOperation() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };
                        for (var validatorName in popup.routeOperationValidator) {
                            var isValid = popup.routeOperationValidator[validatorName](popup.routeOperation);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }
                        console.log('validationResult')
                        console.log(validationResult)
                        return validationResult;
                    }

                    popup.saveRouteOperation = function (form) {

                        var validationResult = validateRouteOperation();
                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }


                        var routeOperation = angular.copy(popup.routeOperation);
                        routeOperation.details.quantity = parseFloat(routeOperation.details.quantity);

                        routeOperation.scheduled = moment(routeOperation.scheduled).format('HH:mm:ss');


                        if (routeOperation.details.tank) {
                            routeOperation.details.tank_id = routeOperation.details.tank.id;
                            delete routeOperation.details.tank;
                        }
                        if (!popup.set_product_volume) {
                            delete routeOperation.details.product_volume;
                        } else {
                            routeOperation.details.product_volume = parseFloat(routeOperation.details.product_volume);
                        }


                        var callbackRouteOperation = function (success, data) {
                            block_form_route_operation.stop();
                            if (success) {
                                refreshRouteOperations();
                                NotifyService.Success('', false);
                                popup.closeModal();
                            }
                        }

                        block_form_route_operation.start();
                        if (!routeOperation.id) {
                            RoutesTerminalService.AddRouteOperation($routeParams.routeID, routeOperation, callbackRouteOperation)
                        } else {
                            RoutesTerminalService.UpdateRouteOperation($routeParams.routeID, routeOperation.id, routeOperation, callbackRouteOperation)
                        }
                    }

                    popup.addTank = function () {
                        window.open(`/tanks-linked/create?${paramsToUrlQueryEncodeURIComponent({
                            customerId: popup.searchCustomerField.searchCustomer.id,
                            phone: popup.searchCustomerField.searchCustomer.phone,
                            email: popup.searchCustomerField.searchCustomer.email
                        })}`, '_blank');
                        popup.closeModal();
                    }

                    popup.closeModal = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.refreshRouteOperations = refreshRouteOperations;
        $scope.getRoutesTerminal = getRoutesTerminal;

        function getRoutesTerminal() {
            block_routes_terminal_list.start();
            var params = angular.copy($scope.params);

            if (params.terminal) {
                if (params.terminal.id !== '0') {
                    params.terminal_id = params.terminal.id;
                }

                delete params.terminal;
            }
            if (params.date) {
                params.date = moment(params.date).format('YYYY-MM-DD')
            }

            RoutesTerminalService.GetRoutesTerminal(params, function (success, data) {
                if (success) {
                    $scope.routesTerminal = angular.copy(data.data);
                    $scope.routesTerminalSummary = angular.copy(data.summary);
                }

                block_routes_terminal_list.stop();
            });
        }

        $scope.saveRoutesTerminal = function (form, needClose) {
            var route = angular.copy($scope.route);
            if (route.terminal) {
                route.terminal_id = route.terminal.id;
                delete route.terminal;
            }

            route.date = moment(route.date).format('YYYY-MM-DD')


            var routeValidator = {
                isDateValid: function (formData) {

                    var form = formData || route;
                    return !!form && !!form.date && form.date !== 'Invalid date';
                },
                isTerminalValid: function (formData) {
                    var form = formData || route;
                    return !!form && !!form.terminal_id;
                },
            }

            function validateRoute() {
                var validationResult = {
                    isValid: true,
                    corruptedFields: []
                };
                for (var validatorName in routeValidator) {
                    var isValid = routeValidator[validatorName](route);
                    if (!isValid) {
                        validationResult.corruptedFields.push(validatorName);
                        validationResult.isValid = false;
                    }
                }
                return validationResult;
            }

            var validationResult = validateRoute();
            $scope.data.corruptedFields = validationResult.corruptedFields;
            if (!validationResult.isValid) {
                return;
            }


            if (form.$valid) {
                block_route_form.start();

                function callbackResult(success, data) {
                    if (success) {
                        $scope.data.minDate = moment(data.date);
                        NotifyService.Success('', false);
                        if (needClose) {
                            $location.path('/routes-terminal');
                        } else if (!$routeParams.routeID) {
                            $location.path('/routes-terminal/edit/' + data.id);
                        }
                    }
                    block_route_form.stop();
                }

                if (isPageMode('create')) {
                    RoutesTerminalService.AddRoute(
                        route,
                        callbackResult)
                } else {
                    RoutesTerminalService.UpdateRoute(
                        $routeParams.routeID,
                        route,
                        callbackResult)
                }

            }
        }

        $scope.isPageMode = isPageMode;

        function isPageMode(mode) {
            return mode === $scope._pageMode;
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }


        $scope.onRoutesTerminalExport = function (format) {
            var isExportStopped = false;
            // TODO dsвынестиоздание модального окна в exportService
            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    }

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_routes_terminal_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;
            block_routes_terminal_list.start();
            var params = angular.copy($scope.params);
            delete params.sorting;
            delete params.order;
            if (params.terminal) {
                if (params.terminal.id !== '0') {
                    params.terminal_id = params.terminal.id;
                }

                delete params.terminal;
            }

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_router_terminal';

                var export_struct = [];
                for (var i in $scope.table_cols) {
                    if ($scope.table_cols[i].visible) {
                        for (var k in $scope.table_cols[i].data) {
                            export_struct.push({
                                text: $filter('translate')($scope.table_cols[i].data[k].text),
                                value: $scope.table_cols[i].data[k].value
                            });
                        }
                    }
                }

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;

                        switch (export_struct[k].value) {
                            case 'created':
                                b = $filter('date')(tl[i]['created'], 'mediumDate') + ' ' + $filter('date')(tl[i]['created'], 'mediumTime');
                                break;
                            case 'suspended':
                                b = tl[i]['suspended'] === 1 ? $filter('translate')('Yes') : $filter('translate')('No');
                                break;
                            case 'terminal_title':
                                b = [];
                                if (tl[i]['terminals']) {
                                    for (var y in tl[i]['terminals']) {
                                        b.push((tl[i]['terminals'][y]['title'] || ' - '))
                                    }
                                }
                                b = b.join("\n");
                                break;

                            case 'terminal_id':
                                b = [];
                                if (tl[i]['terminals']) {
                                    for (var y in tl[i]['terminals']) {
                                        b.push((tl[i]['terminals'][y]['id'] || ' - '))
                                    }
                                }
                                b = b.join("\n");
                                break;
                            case 'terminal_type':
                                b = [];
                                if (tl[i]['terminals']) {
                                    for (var y in tl[i]['terminals']) {
                                        var tb = ' - ';
                                        switch (tl[i]['terminals'][y]['type']) {
                                            case 'register':
                                                tb = $filter('translate')('TEXT_MODE_REGISTER')
                                                break;
                                            case 'steward':
                                                tb = $filter('translate')('TEXT_MODE_STEWARD')
                                                break;
                                            case 'validator':
                                                tb = $filter('translate')('TEXT_MODE_VALIDATOR')
                                                break;
                                            case 'prepaid-services':
                                                tb = $filter('translate')('TEXT_MODE_PREPAID_SERVICES')
                                                break;
                                            case 'road-tanker-driver':
                                                tb = $filter('translate')('TEXT_MODE_ROAD_TANKER_DRIVER')
                                                break;
                                            case 'kiosk':
                                                tb = $filter('translate')('TEXT_MODE_KIOSK')
                                                break;
                                        }
                                        b.push(tb);
                                    }
                                }
                                b = b.join("\n");
                                break;

                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : $filter('translate')(tl[i][export_struct[k].value]);
                        }
                        el[a] = b;
                    }
                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                    block_routes_terminal_list.stop();
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }
            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.routesTerminalSummary.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise((resolve) => {
                    getRoutesTerminal(exportParams[currentPage]).then(resp => {
                        exportValues = [...exportValues, resp]
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.routesTerminalSummary.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(response => {
                                resolve(response);
                            })
                        } else {
                            resolve({currentPage});
                        }
                    });
                })
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(response => {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                })
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;
                tl.forEach(function (item) {
                    item.id = item.user_id;
                });
                generateFile();
            }

            function getRoutesTerminal(params) {
                return new Promise(function (resolve) {
                    routesTerminalService.GetsStaff(params, function (success, response) {
                        resolve(response);
                    });
                })
            }

            exportRequest();
        }

        $scope.pager_count = [10, 20, 50, 100, 200];

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting': !!row.sorting,
                'sorting_asc': !!row.sorting && $scope.params.sort === row.sorting && $scope.params.order === 'asc',
                'sorting_desc': !!row.sorting && $scope.params.sort === row.sorting && $scope.params.order === 'desc'
            }
        };


        $scope.onSortOrderChange = function (row) {
            if (!row.sorting) {
                return;
            }
            if ($scope.params.sort === row.sorting)
                $scope.params.order = $scope.params.order === "asc" ? "desc" : "asc";
            else
                $scope.params.order = "asc";

            $scope.params.sort = row.sorting;
            getRoutesTerminal();
        }
        $scope.pageChange = function () {
            getRoutesTerminal();
        };

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                var allTerminal = {
                    title: $filter('translate')('All terminals'),
                    id: '0',
                    filter_list_type: 'register',
                    active: 1
                };
                var LPR_LIST = newValue;
                if (newValue[0].id !== allTerminal.id) {
                    LPR_LIST.unshift(allTerminal);
                }


                $scope.LPR_LIST = LPR_LIST;

                if (!$scope.params.terminal) {
                    $scope.params.terminal = allTerminal;
                }
            }
        })

        $scope.withOutAllTerminal = function (item) {
            return item.id !== '0'
        }
        /**
         *
         * @param count
         */
        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getRoutesTerminal();
        };

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                var allTerminal = {
                    title: $filter('translate')('All terminals'),
                    id: '0',
                    filter_list_type: 'register',
                    active: 1
                };
                var LPR_LIST = newValue;
                if (newValue[0].id !== allTerminal.id) {
                    LPR_LIST.unshift(allTerminal);
                }


                $scope.LPR_LIST = LPR_LIST;

                if (!$scope.params.terminal) {
                    $scope.params.terminal = allTerminal;
                }
            }
        })

        $scope.withOutAllTerminal = function (item) {
            return item.id !== '0'
        }
    }
})();
